<rk-form-field>
    @if (pageNameError$ | async) {
        <div class="form-error-message">
            {{ 'menu-content.title-error' | translate }}
        </div>
    }
</rk-form-field>
